import CopyKit from './CopyKit'
import CopyKitModal from './CopyKitModal'


export default CopyKit
export { CopyKitModal }
